import { Fragment } from 'react';
import VideoDisplay from './video';
import { OptionsDisplay, CommunityPageType } from './options';

const InfoDisplay = ({ images, lang, links }) => (
   <Fragment>
      <OptionsDisplay
         images={images}
         lang={lang}
         links={links}
         page={CommunityPageType.LANDING_PAGE}
      />
      <VideoDisplay links={links} />
   </Fragment>
);

export default InfoDisplay;
